/**
 * Professional Bully (291) damage display sync helpers.
 * Bully fist/sound timing is owned by the bully ghost sequence — not strategem HP holds.
 */

export function filterHealthHoldTargetsExcludingBullyDamage(holdTargets, bullyDamageInstanceIds) {
  if (!Array.isArray(holdTargets) || holdTargets.length === 0) {
    return [];
  }
  if (!Array.isArray(bullyDamageInstanceIds) || bullyDamageInstanceIds.length === 0) {
    return holdTargets;
  }
  const bullySet = new Set(bullyDamageInstanceIds);
  return holdTargets.filter((target) => !bullySet.has(target?.targetInstanceId));
}

export function hasActiveStrategemAnimationsForInstance(activeAnimations, strategemInstanceId) {
  if (strategemInstanceId == null || !Array.isArray(activeAnimations)) {
    return false;
  }
  const instanceKey = String(strategemInstanceId);
  return activeAnimations.some(
    (anim) => anim?.strategemInstanceId != null && String(anim.strategemInstanceId) === instanceKey
  );
}
